import React from 'react'

import Icon, { IconProps } from './Icon'

/**
 * 電話アイコン
 */
const TelIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
      >
        <path
          d="M12.333,10h1.556A3.89,3.89,0,0,0,10,6.111V7.667A2.33,2.33,0,0,1,12.333,10Zm3.111,0H17a7,7,0,0,0-7-7V4.556A5.44,5.44,0,0,1,15.444,10Zm.778,2.722a8.836,8.836,0,0,1-2.777-.443.867.867,0,0,0-.241-.039.8.8,0,0,0-.552.226l-1.711,1.711A11.7,11.7,0,0,1,5.816,9.051L7.527,7.332a.747.747,0,0,0,.194-.778,8.836,8.836,0,0,1-.443-2.777A.78.78,0,0,0,6.5,3H3.778A.78.78,0,0,0,3,3.778,13.221,13.221,0,0,0,16.222,17,.78.78,0,0,0,17,16.222V13.5A.78.78,0,0,0,16.222,12.722ZM4.579,4.556H5.746A10.722,10.722,0,0,0,6.1,6.562L5.162,7.5A11.937,11.937,0,0,1,4.579,4.556ZM15.444,15.421a11.59,11.59,0,0,1-2.956-.591l.933-.933a9.919,9.919,0,0,0,2.022.35Z"
          transform="translate(-3 -3)"
        />
      </svg>
    </Icon>
  )
}

export default TelIcon
